import { PHONE_NO_REGEX } from 'global/appConstants';
import yup from 'utils/yup';

export const initialProfileFormData = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
};

export const profileValidationSchema = yup.object().shape({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  email: yup.string().required(),
  phone: yup.string().matches(PHONE_NO_REGEX, () => ({ msg: 'common:yup.default' })),
});
